import React, { FunctionComponent } from 'react';
import { Box, InputLabel, Typography } from '@material-ui/core';
import TextTooltip from '../../../summary/components/common/TextTooltip/TextTooltip';
import HelpIcon from '@material-ui/icons/Help';
import genericInputStyles from './GenericInputStyles';

interface IGenericInputLabelProps {
  label: string;
  id: string;
  required: boolean;
  tooltip: string;
}

export const GenericInputLabel: FunctionComponent<IGenericInputLabelProps> = ({ id, label, required, tooltip }) => {
  const styles = genericInputStyles();

  return (
    <Box display={'flex'}>
      <Typography component={'span'} variant={'subtitle1'}>
        <InputLabel htmlFor={id} required={required} className={styles.label} data-test={`text_input:label:${id}`}>
          {label}
        </InputLabel>
      </Typography>
      {tooltip && (
        <TextTooltip
          id={id}
          text={tooltip}
          content={
            <Box component={'span'}>
              <HelpIcon color="primary" viewBox="0 0 28 28" fontSize="small" />
            </Box>
          }
        />
      )}
    </Box>
  );
};
